import { Switch, Route } from 'react-router-dom';

import List from './List';

export default () => {
  const BASE_URL = '/admin/room/details/:room/poll';

  return (
    <Switch>
      <Route
        path={[`${BASE_URL}`, `${BASE_URL}/new`, `${BASE_URL}/:poll`]}
        component={List}
        exact
      />
    </Switch>
  );
};
